<template>
  <a-modal
    wrapClassName="customModal"
    v-model="showDialog"
    :title="`${dialogType == 1 ? '添加设备' : '编辑设备'}`"
    centered
    :width="660"
    destroyOnClose
    :maskClosable="false"
    @ok="confirmAdd"
    @cancel="afterClose"
  >
    <div class="dialog-body">
      <a-form-model ref="ruleForm" :model="deviceForm" :rules="rules">
        <a-form-model-item ref="deviceStatus" label="启用状态" prop="deviceStatus">
          <a-switch v-model="deviceForm.deviceStatus" />
        </a-form-model-item>
        <a-form-model-item ref="deviceName" label="设备名称" prop="deviceName">
          <a-input v-model="deviceForm.deviceName" placeholder="请输入设备名称" style="width: 240px" />
        </a-form-model-item>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item ref="accessMode" label="接入方式" prop="accessMode">
              <a-select
                v-model="currentAccessMode"
                style="width: 160px; margin-bottom: 10px"
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                @change="handleAccessMode"
              >
                <a-select-option :value="mode.id" v-for="mode in accessModeList" :key="mode.id">
                  {{ mode.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="currentAccessMode == '1'">
            <a-form-model-item ref="modeCheck" prop="modeCheck">
              <a-checkbox-group v-model="checkValue" name="checkboxgroup" @change="onCheckChange">
                <a-checkbox value="1">onvif接入</a-checkbox>
                <a-checkbox value="2">rtsp/rtmp接入</a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item ref="mediaType" label="媒体类型" prop="mediaType">
          <a-checkbox-group v-model="selectMediaType" name="checkboxgroup" @change="onMediaTypeChange">
            <a-checkbox value="1">视频</a-checkbox>
            <a-checkbox value="2">音频</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-row :gutter="24">
          <a-col :span="12" v-if="selectMediaType.includes('1')">
            <a-form-model-item ref="videoDisplayName" label="视频设备名称" prop="videoDisplayName">
              <a-input v-model="deviceForm.videoDisplayName" placeholder="请输入视频设备名称" style="width: 160px" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="selectMediaType.includes('2')">
            <a-form-model-item ref="audioDisplayName" label="音频设备名称" prop="audioDisplayName">
              <a-input v-model="deviceForm.audioDisplayName" placeholder="请输入音频设备名称" style="width: 160px" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="selectMediaType.includes('1')">
          <a-col :span="12">
            <a-form-model-item class="role-type-item" ref="deviceType" label="机位类型" prop="deviceType">
              <a-select
                v-model="deviceForm.deviceType"
                :default-value="typeList[0].value"
                style="width: 160px; margin-bottom: 10px"
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              >
                <a-select-option :value="type.value" v-for="type in typeList" :key="type.value">
                  {{ type.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item ref="defaultVideo" label="设置为默认视频设备" prop="defaultVideo">
              <a-switch v-model="deviceForm.defaultVideo" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="selectMediaType.includes('2')">
          <a-col :span="12">
            <a-form-model-item ref="defaultAudio" label="设置为默认音频设备" prop="defaultAudio">
              <a-switch v-model="deviceForm.defaultAudio" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <template v-if="checkValue.includes('1')">
          <div class="access-type" v-if="checkValue.includes('1')">onvif接入</div>
          <!-- <div class="access-type" v-if="currentAccessMode == '5'">zrtc拉流方式</div> -->
          <a-form-model-item ref="manufacturerId" label="相机类型" prop="manufacturerId">
            <a-select
              v-model="deviceForm.manufacturerId"
              style="width: 160px; margin-bottom: 15px"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            >
              <a-select-option v-for="item in deviceTypeList" :value="item.id" :key="item.id">
                {{ item.deviceFactoryName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                ref="ipAddress"
                label="IP地址"
                :prop="deviceForm.manufacturerId !== 0 ? 'ipAddress' : ''"
              >
                <a-input
                  v-model="deviceForm.ipAddress"
                  placeholder="例如：192.168.50.47"
                  style="width: 160px"
                  @change="getRTSPUrlThrottleByAdd"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item ref="port" label="端口号" prop="port">
                <a-input
                  v-model="deviceForm.port"
                  placeholder="例如：554"
                  style="width: 160px"
                  @change="getRTSPUrlThrottleByAdd"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item ref="loginName" label="登录名" prop="loginName">
                <a-input
                  v-model="deviceForm.loginName"
                  placeholder="例如：admin"
                  style="width: 160px"
                  @change="getRTSPUrlThrottleByAdd"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item ref="password" label="密码" prop="password">
                <a-input
                  v-model="deviceForm.password"
                  placeholder="例如：able1234"
                  style="width: 160px"
                  @change="getRTSPUrlThrottleByAdd"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item ref="controllerUsername" label="球机操控用户" prop="controllerUsername">
                <a-input v-model="deviceForm.controllerUsername" placeholder="例如：admin" style="width: 160px" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item ref="controllerPassword" label="球机操控密码" prop="controllerPassword">
                <a-input v-model="deviceForm.controllerPassword" placeholder="例如：able1234" style="width: 160px" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-form-model-item ref="controllerPort" label="球控端口号" prop="controllerPort">
            <a-input v-model="deviceForm.controllerPort" placeholder="例如：2000" style="width: 260px" />
          </a-form-model-item>
          <a-form-model-item
            v-show="deviceForm.manufacturerId !== 0"
            ref="manufacturerPath"
            label="rtsp地址"
            prop="manufacturerPath"
          >
            <a-input
              v-model="deviceForm.manufacturerPath"
              disabled
              placeholder="例如：rtsp://admin:admin@192.168.49.103:554/PSIA/Streaming/channels/1"
              style="width: 260px"
            />
            <a-button @click="doCopy" style="margin-left: 10px; border-radius: 0; margin-top: 1px">复制</a-button>
          </a-form-model-item>
          <p class="ip-tips" v-show="deviceForm.manufacturerId !== 0">
            建议使用Vlc、Potplayer等支持RTSP的播放器，测试生成地址能否正常播放！
          </p>
          <!-- <a-form-model-item
            ref="rtspProxyUrl"
            label="转发服务器url"
            prop="rtspProxyUrl"
            v-if="currentAccessMode == '5'"
          >
            <a-input v-model="deviceForm.rtspProxyUrl" placeholder="例：http://127.0.0.1:8080" style="width: 260px" />
          </a-form-model-item>
          <a-form-model-item v-if="currentAccessMode == '5'" ref="test" label="设备标识" prop="test">
            <a-input v-model="deviceForm.test" placeholder="" style="width: 260px" />
          </a-form-model-item> -->
        </template>
        <template v-if="checkValue.includes('2')">
          <div class="access-type">rtsp/rtmp接入</div>
          <a-form-model-item prop="rtspUrl" ref="rtspUrl" label="rtsp/rtmp地址">
            <a-input
              v-model="deviceForm.rtspUrl"
              placeholder="例如：rtsp://admin:admin@192.168.49.103:554/PSIA/Streaming/channels/1"
              style="width: 260px"
            />
          </a-form-model-item>
        </template>
        <template v-if="currentAccessMode == '3'">
          <div class="access-type">webrtc接入</div>
          <a-form-model-item prop="classroomGomsgUrl" ref="classroomGomsgUrl" label="信控中心Url">
            <a-input v-model="deviceForm.classroomGomsgUrl" placeholder="请输入信控中心地址" style="width: 260px" />
          </a-form-model-item>
        </template>
        <template v-if="currentAccessMode == '5'">
          <div class="access-type">zrtc拉流方式</div>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item ref="loginName" label="登录名" prop="loginName">
                <a-input v-model="deviceForm.loginName" placeholder="例如：admin" style="width: 160px" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item ref="password" label="密码" prop="password">
                <a-input v-model="deviceForm.password" placeholder="例如：able1234" style="width: 160px" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-form-model-item ref="rtspProxyUrl" label="转发服务器url" prop="rtspProxyUrl">
            <a-input v-model="deviceForm.rtspProxyUrl" placeholder="例：http://127.0.0.1:8080" style="width: 260px" />
          </a-form-model-item>
          <a-form-model-item ref="test" label="设备标识" prop="test">
            <a-input v-model="deviceForm.test" placeholder="" style="width: 260px" />
          </a-form-model-item>
          <a-form-model-item prop="rtspUrl" ref="rtspUrl" label="rtsp/rtmp地址">
            <a-input
              v-model="deviceForm.rtspUrl"
              placeholder="例如：rtsp://admin:admin@192.168.49.103:554/PSIA/Streaming/channels/1"
              style="width: 260px"
            />
          </a-form-model-item>
        </template>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { channelTypeOptions } from '../../../../utils/enumerate'
import _ from 'lodash'
export default {
  props: {
    showAddDeviceDialogProp: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: Number,
      default: 1
    },
    classroomCode: {
      type: String
    },
    deviceId: {
      type: String | Number
    }
  },
  watch: {
    async showAddDeviceDialogProp(val, old) {
      this.showDialog = val
      if (val == true) {
        await this.getManuFacturerInfo()
        await this.getDeviceTypes()
        if (this.deviceId) {
          await this.getDeviceInfoDetail()
        }
      }
    }
  },
  data() {
    let validateRoleType = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择机位类型'))
      } else {
        if (this.deviceForm.deviceType == 0 || '') {
          callback(new Error('请选择机位类型'))
        }
        callback()
      }
    }
    let validateAccessMode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择接入方式'))
      } else {
        if (this.deviceForm.accessMode == '') {
          callback(new Error('请选择接入方式'))
        }
        callback()
      }
    }
    let validateModeCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择至少一个方式'))
      } else {
        if (this.checkValue == [] || !this.checkValue.length) {
          callback(new Error('请选择至少一个方式'))
        }
        callback()
      }
    }
    return {
      showDialog: false,
      selectSchool: this.$route.query.selectSchool,
      labelCol: { span: 4 },
      wrapperCol: { span: 8 },
      checkValue: [],
      currentAccessMode: '',
      selectMediaType: [],
      mediaOptions: [
        { label: '视频', value: '1' },
        { label: '音频', value: '2' }
      ],
      accessModeList: [
        { id: '1', name: '插件推流' },
        { id: '3', name: '主机推流' },
        { id: '4', name: '手机接入' },
        { id: '5', name: 'zrtc拉流' }
      ],
      deviceForm: {
        classroomCode: '',
        schoolCode: '',
        deviceStatus: false, // 设备状态 0 未启用 1 已启用
        cameraCode: '', // 球机编号
        deviceName: '', // 设备名称
        deviceType: '', // 0 未定义 1 老师 2 学生 3 课件
        supportAudio: false,
        supportVideo: false,
        defaultAudio: false,
        defaultVideo: false,
        mediaType: [],
        accessMode: '',
        channelType: 0,
        devicePassword: '',
        manufacturerId: '',
        ipAddress: '',
        loginName: '',
        password: '',
        controllerUsername: '',
        controllerPassword: '',
        controllerPort: '',
        port: '',
        manufacturerPath: '',
        videoDisplayName: '',
        audioDisplayName: '',
        classroomGomsgUrl: '',
        rtspProxyUrl: '',
        test: ''
      },
      rules: {
        deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        accessMode: [{ validator: validateAccessMode, trigger: 'blur' }],
        modeCheck: [{ validator: validateModeCheck, trigger: 'blur' }],
        mediaType: [{ required: true, message: '请至少选择一个媒体类型', trigger: 'change' }],
        deviceType: [{ validator: validateRoleType, trigger: 'blur' }],
        ipAddress: [{ required: true, message: '请输入IP地址', trigger: 'change' }],
        rtspUrl: [{ required: true, message: '请输入rtsp地址', trigger: 'change' }],
        manufacturerId: [{ required: true, message: '请输入选择相机类型', trigger: 'change' }],
        port: [{ required: true, message: '请输入端口号', trigger: 'change' }],
        loginName: [{ required: true, message: '请输入登录名', trigger: 'change' }],
        password: [{ required: true, message: '请输入密码', trigger: 'change' }],
        controllerUsername: [{ required: true, message: '请输入球机操控用户名', trigger: 'change' }],
        controllerPassword: [{ required: true, message: '请输入球机操控密码', trigger: 'change' }],
        controllerPort: [{ required: true, message: '请输入球控端口号', trigger: 'change' }],
        classroomGomsgUrl: [{ required: true, message: '请输入信控中心地址', trigger: 'change' }],
        rtspProxyUrl: [{ required: true, message: '请输入转发服务器地址', trigger: 'change' }],
        test: [{ required: true, message: '请输入设备标识', trigger: 'change' }]
      },
      channelTypeOptions,
      deviceTypeList: [], // 球机类型及其rtsp地址
      isShowConfigInfo: false,
      isShowConfigReWrite: false,
      isShowErrorInfo: '',
      typeList: [], // 机位类型
      showCheckbox: false
    }
  },
  methods: {
    afterClose() {
      this.$emit('update:showAddDeviceDialogProp', false)
      this.clearForm()
    },
    onCheckChange(check) {
      console.log('check🔧:>>>>>>>', check, 'addDeviceDialog.vue')
      this.checkValue = check
      this.deviceForm.accessMode = this.checkValue.join(',')
    },
    handleAccessMode(mode) {
      console.log('mode🔧:>>>>>>>', mode, 'addDeviceDialog.vue')
      if (mode !== '1') {
        this.checkValue = []
        this.currentAccessMode = mode
        this.deviceForm.accessMode = mode
      }
    },
    onMediaTypeChange(check) {
      this.selectMediaType = check
      this.deviceForm.mediaType = check
    },
    onPhoneChange(value) {
      this.checkValue = ['4']
      this.deviceForm.accessMode = this.checkValue.join(',')
      console.log('value🔧:>>>>>>>', value, 'addDevice.vue')
    },
    async getDeviceInfoDetail() {
      const res = await this.$http.getDeviceDetail({
        id: this.deviceId
      })
      console.log('设备详情🔧:>>>>>>>', res, 'addDevice.vue')
      if (res.code === 200 && res.rt) {
        this.deviceForm = res.rt
        this.checkValue = res.rt.accessMode.split(',')
        this.deviceForm.mediaType = []
        if (res.rt.supportVideo) {
          this.selectMediaType.push('1')
          this.deviceForm.mediaType.push('1')
        }
        if (res.rt.supportAudio) {
          this.selectMediaType.push('2')
          this.deviceForm.mediaType.push('2')
        }
        this.deviceForm.deviceStatus = Boolean(res.rt.deviceStatus)
        this.deviceForm.defaultAudio = Boolean(res.rt.defaultAudio)
        this.deviceForm.defaultVideo = Boolean(res.rt.defaultVideo)
        this.deviceForm.supportAudio = Boolean(res.rt.supportAudio)
        this.deviceForm.supportVideo = Boolean(res.rt.supportVideo)
        console.log('this.checkValue🔧:>>>>>>>', this.checkValue, 'addDeviceDialog.vue')
        if (this.checkValue.includes('1') || this.checkValue.includes('2')) {
          this.currentAccessMode = '1'
        } else if (this.checkValue.includes('3')) {
          this.currentAccessMode = '3'
        } else if (this.checkValue.includes('4')) {
          this.currentAccessMode = '4'
        } else if (this.checkValue.includes('5')) {
          this.currentAccessMode = '5'
        }
      }
    },
    async getDeviceTypes() {
      const res = await this.$http.getAllDeviceTypes()
      console.log('res-role🔧:>>>>>>>', res, 'addDeviceDialog.vue')
      if (res.code === 200 && res.rt && res.rt.length) {
        this.typeList = res.rt
        this.deviceForm.deviceType = res.rt[0].value
      }
    },
    async confirmAdd() {
      this.$refs.ruleForm.validate(async (valid) => {
        console.log(
          'selectMediaType🔧:>>>>>>>',
          this.selectMediaType,
          this.deviceForm.mediaType,
          this.checkValue,
          'addDeviceDialog.vue'
        )
        if (valid) {
          try {
            let {
              cameraCode,
              deviceName,
              deviceType,
              deviceStatus,
              defaultAudio,
              defaultVideo,
              accessMode,
              ipAddress,
              controllerUsername,
              controllerPassword,
              controllerPort,
              loginName,
              password,
              port,
              rtspUrl,
              manufacturerId,
              manufacturerPath,
              videoDisplayName,
              audioDisplayName,
              classroomGomsgUrl,
              rtspProxyUrl,
              test
            } = this.deviceForm

            let id = this.deviceForm.manufacturerId
            let device = this.deviceTypeList.find((item) => item.id == id) || {}
            let rtspAddress = device.rtspAddress || ''

            let params = {
              classroomCode: this.classroomCode,
              schoolCode: Number(this.selectSchool),
              cameraCode: cameraCode,
              deviceName: deviceName,
              deviceType: this.selectMediaType.includes('1') ? deviceType : '',
              deviceStatus: deviceStatus ? 1 : 0,
              supportAudio: this.selectMediaType.includes('2') ? 1 : 0,
              supportVideo: this.selectMediaType.includes('1') ? 1 : 0,
              defaultAudio: this.selectMediaType.includes('2') && defaultAudio ? 1 : 0,
              defaultVideo: this.selectMediaType.includes('1') && defaultVideo ? 1 : 0,
              accessMode: accessMode,
              ipAddress: ipAddress,
              port: port,
              loginName: loginName,
              password: password,
              manufacturerId: manufacturerId,
              controllerUsername: controllerUsername,
              controllerPassword: controllerPassword,
              controllerPort: controllerPort,
              rtspUrl: rtspUrl,
              videoDisplayName: videoDisplayName,
              audioDisplayName: audioDisplayName,
              classroomGomsgUrl: classroomGomsgUrl,
              rtspProxyUrl: rtspProxyUrl,
              test: test
            }
            // onvif接入 需要获取manuFacturerPath
            if (accessMode.includes('1')) {
              let rtspPath = ''
              rtspPath = await this.$http.getRtspPath({
                ipAddress: ipAddress,
                loginName: loginName,
                passWord: password,
                deviceModel: 1,
                manuFacturerId: manufacturerId,
                manuFacturerPath: rtspAddress,
                port: port
              })
              if (!(rtspPath.code == 200 && rtspPath.rt)) return this.$message.warning('获取RTSP地址失败!')
              this.deviceForm.manufacturerPath = rtspPath.rt || ''
            }
            // 添加/编辑
            if (this.dialogType == 1) {
              this.creatDevice(params)
            } else {
              params.id = this.deviceId
              this.editDevice(params)
            }
          } catch (err) {
            console.log(err)
          }
        }
      })
    },
    async creatDevice(params) {
      const res = await this.$http.addDevice(params)
      console.log('新增设备res🔧:>>>>>>>', res, 'addDevice.vue')
      if (res.code === 200) {
        if (res.rt.resultStatus == 1) {
          this.$message.success(res.rt.resultMessage)
          this.$emit('update:showAddDeviceDialogProp', false)
          this.clearForm()
          this.$emit('updateDeviceList')
        } else if (res.rt.resultStatus && res.rt.resultStatus == -1) {
          this.$message.error(res.rt.resultMessage)
        }
      }
    },
    async editDevice(params) {
      const res = await this.$http.updateDevice(params)
      console.log('编辑设备res🔧:>>>>>>>', res, 'addDevice.vue')
      if (res.code === 200) {
        if (res.rt.resultStatus == 1) {
          this.$message.success(res.rt.resultMessage)
          this.$emit('update:showAddDeviceDialogProp', false)
          this.clearForm()
          this.$emit('updateDeviceList')
        } else if (res.rt.resultStatus && res.rt.resultStatus == -1) {
          this.$message.error(res.rt.resultMessage)
        }
      }
    },
    clearForm() {
      this.deviceForm = {
        deviceName: '',
        deviceType: '',
        deviceStatus: false,
        supportAudio: false,
        supportVideo: false,
        defaultAudio: false,
        defaultVideo: false,
        mediaType: [],
        accessMode: '',
        ipAddress: '',
        controllerUsername: '',
        controllerPassword: '',
        controllerPort: '',
        loginName: '',
        password: '',
        port: '',
        rtspUrl: '',
        manufacturerId: 0,
        manufacturerPath: '',
        videoDisplayName: '',
        audioDisplayName: '',
        classroomGomsgUrl: ''
      }
      this.checkValue = []
      this.selectMediaType = []
    },
    async getManuFacturerInfo() {
      let res = await this.$http.getManuFacturerInfo()
      if (res.code !== 200) return this.$message.error('获取设备类型列表失败!')
      this.deviceTypeList = res.rt || []
      this.deviceForm.manufacturerId = this.deviceTypeList[0]?.id || ''
    },
    getRTSPUrlThrottleByAdd: _.throttle(function () {
      let { loginName, password, ipAddress, port, manufacturerId } = this.deviceForm
      let id = this.deviceForm.manufacturerId
      let device = this.deviceTypeList.find((item) => item.id == id) || {}
      let rtspAddress = device.rtspAddress || ''
      this.getRTSP({
        ipAddress: ipAddress,
        loginName: loginName,
        passWord: password,
        deviceModel: 1,
        manuFacturerId: manufacturerId,
        manuFacturerPath: rtspAddress,
        port: port,
        isAdd: true
      })
    }, 200),
    /**
     * @description: 实时获取RTSP地址
     * @param {*}
     * @return {*}
     */
    async getRTSP(options) {
      const { isAdd } = options
      let rtspUrl = await this.$http.getRtspPath(options)
      if (!(rtspUrl.code == 200)) return this.$message.warning('获取RTSP地址失败!')
      if (isAdd) {
        this.deviceForm.manufacturerPath = rtspUrl.rt
      }
    },
    doCopy() {
      this.$copyText(this.deviceForm.manufacturerPath || ' ').then(
        (e) => {
          this.$message.success('复制成功!')
        },
        (e) => {
          this.$message.error('复制失败!')
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-color: #5f60d3;
.dialog-body {
  padding: 16px 0;
  .access-type {
    margin-bottom: 15px;
    font-size: 16px;
    color: #1e2228;
  }
  .ip-tips {
    color: #f37f61;
    margin: -16px 0 10px;
  }
  .role-type-item {
    position: relative;
    &::before {
      display: inline-block;
      position: absolute;
      top: 3px;
      left: 30px;
      font-size: 20px;
      color: #f5222d;
      content: '*';
    }
  }
}
::v-deep .ant-modal-body {
  padding: 0 16px;
  max-height: 500px;
  overflow-y: auto;
  border-bottom: 1px solid #e7e7e7;
  .ant-form-item {
    display: flex;
    margin-bottom: 12px;
    vertical-align: middle;
  }
  .ant-form-item-control {
    line-height: 32px;
  }
  .ant-form-item-children {
    display: flex;
  }
  .ant-form-item-label {
    min-width: 110px;
    margin-top: -2px;
  }
  .ant-form-item .ant-switch {
    margin: 7px 0 4px;
  }
  .ant-btn-background-ghost.ant-btn-primary {
    width: 80px;
    height: 32px;
    color: $primary-color;
    border-color: $primary-color;
  }
  .ant-table-pagination.ant-pagination {
    display: none;
  }
  .ant-checkbox-group {
    padding-top: 7px;
  }
}
::v-deep .ant-modal-footer {
  padding: 20px;
  border-top: none;
  text-align: center;
  .ant-btn {
    width: 108px;
    height: 38px;
    border: 1px solid #5f60d3;
    color: #5f60d3;
  }
  .ant-btn-primary {
    margin-left: 16px;
    background: #5f60d3;
    color: #fff;
  }
}
</style>
